<template>
  <div class="time_sheet">
    <el-table :data="tableData" border v-loading="loading">
      <el-table-column v-for="(item, index) in listLabel" :key="index" :prop="item.prop" :label="item.label"
        :fixed="index===0" min-width="100px">
      </el-table-column>
    </el-table>
    <el-pagination background layout="prev, pager, next" :total="allTotal" class="page_content"
      @current-change="currentChange" @prev-click="prevClick" @next-click="nextClick">
    </el-pagination>
    <toast :is-toast="isToast" :msg="toastMsg"></toast>
  </div>
</template>
<script>
  import {
    phpTimesheet
  } from '../../../API/api.js'
  import Toast from "@/components/popup/Toast";
  export default {
    components: {
      Toast
    },
    props: {

      projectInfo: {
        type: Object
      }
    },
    data() {
      return {
        searchParams: {
          limit: 10,
          page: 1,
          Id: this.projectInfo.projectId
        },
        loading: true,
        isToast: false,
        toastMsg: "",
        listLabel: [{
          label: '',
          prop: 'workingDate'
        }, ],
        tableData: [],
        allTotal: 0,
      }
    },
    methods: {
      currentChange(curpage) {
        console.log('123', curpage)
        this.searchParams.page = curpage;
        this.getByIdList();
      },
      prevClick(curpage) {
        this.searchParams.page = curpage;
        this.getByIdList();

      },
      nextClick(curpage) {
        this.searchParams.page = curpage;
        this.getByIdList();
      },
      getTableData() {
        this.listLabel = [{
          label: '',
          prop: 'workingDate'
        }, ];
        this.$http
          .post(phpTimesheet.getdeliverables, this.qs.stringify({
            Id: this.projectInfo.projectId
          }))
          .then((res) => {
            this.loading = false;
            let _data = res.data
            if (_data.retCode === 200) {
              for (let i of _data.retData) {
                // console.log('123',i)
                this.listLabel.push({
                  label:  i.userName +'（总：' + i.sumWorkingHours + '）',
                  prop: String(i.userId)
                })
              }
            } else {
              this.isToast = true;
              this.toastMsg = `${_data.retMsg}`;
            }
            setTimeout(() => {
              this.isToast = false;
              this.toastMsg = "";
            }, 1500);
          })
          .catch((res) => {

          });
      },
      getByIdList() {
        this.tableData = [];
        this.$http
          .post(TimeSheet.getByIdList, this.qs.stringify(this.searchParams))
          .then((res) => {
            let _data = res.data
            if (_data.retCode === 0) {
              console.log(_data.retData.data)
              const _dataArr = []
              this.allTotal = _data.retData.count
              for (let i of _data.retData.data) {
                let userId = i.userId
                _dataArr.push({
                  workingDate: i.workingDate,
                  [`${userId}`]: i.sumWorkingHours,
                  sumWorkingHours: i.sumWorkingHours,
                  userId: i.userId
                })
              }
              let tempArr = [];
              let newArr = [];
              for (let i = 0; i < _dataArr.length; i++) {
                let userId = _dataArr[i].userId;
                if (tempArr.indexOf(_dataArr[i].workingDate) === -1) {
                  newArr.push({
                    workingDate: _dataArr[i].workingDate,
                    [`${_dataArr[i].userId}`]: _dataArr[i].sumWorkingHours,
                  })
                  tempArr.push(_dataArr[i].workingDate);
                } else {
                  for (let j = 0; j < newArr.length; j++) {
                    if (newArr[j].workingDate === _dataArr[i].workingDate) {
                      let obj = {
                        [`${_dataArr[i].userId}`]: _dataArr[i].sumWorkingHours,
                      }
                      newArr[j] = {
                        ...newArr[j],
                        ...obj
                      }
                    }
                  }
                }
              }
              this.tableData = newArr;

            } else {
               this.isToast = true;
              this.toastMsg = `${_data.retMsg}`;
            }
             setTimeout(() => {
              this.isToast = false;
              this.toastMsg = "";
            }, 1500);
          })
          .catch((res) => {

          });
      }
    },
    mounted() {
      this.getTableData();
      // this.getByIdList()
    }
  }

</script>
<style lang="less" scoped>
  .page_content {
    margin-top: 20px;
    display: flex;
    justify-content: end;
  }

</style>
